import { render, staticRenderFns } from "./InboundProcces.vue?vue&type=template&id=01187b63"
import script from "./InboundProcces.vue?vue&type=script&lang=js"
export * from "./InboundProcces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports